export function GetAuthority () {
  if (localStorage.getItem('pcs_time_stamp') > new Date().getTime()) {
    return localStorage.getItem('access_token')
  }
  RemoveAuthority()
  return false
}
export function SetAuthority (key, value) {
  return localStorage.setItem(key, value)
}
export function SetAuthorityExpire () {
  localStorage.setItem('pcs_time_stamp', new Date().getTime() + 43195000) // 12小时
}
export function RemoveAuthority () {
  localStorage.removeItem('access_token')
  localStorage.removeItem('pcs_time_stamp')
}
